import logo from './logo.svg';
import './App.css';
import Home from './components/Home';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Mintingpage from './components/MintingPage';

function App() {
  return (
    <div className="App">
      {/* <Home /> */}
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/Mint" element={<Mintingpage />} />
          {/* <Route exact path="/brandDesign" element={<BrandDesign />} />
        <Route exact path="/landingpages" element={<LandingPages />} />
        <Route exact path="/pitchdeck" element={<PitchDeck />} />
        <Route exact path="/PrivacyAndTerm" element={<PrivacyAndTerm />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
